// language.js


const alltexts = 
    [
        // ******************************************************************************************
        // sidebar texts index 0
        // ******************************************************************************************
        [
            ["Accueil","Home"],             // 0.0
            ["Projets", "Projects"],        // 0.1
            ["Projets en local", "Local Projects"],        // 0.2
            ["Projets externes", "External Projects"],        // 0.3
            ["Sous-titrage", "Subtitling"],        // 0.4
            ["Transcription", "Transcription"],        // 0.5
            ["Sous-titres", "Subtitles"],        // 0.6
            ["Exports", "Exports"],        // 0.7
            ["Paramètres", "Settings"],        // 0.8

            ["Ouvrir le menu","Expand Menu"], // 0.9
            ["Fermer le menu","Close Menu"],  // 0.10
            ["Audio Description, Voice Over","Audio Description, Voice Over"],  // 0.11
            ["Tests","Tests"],  // 0.12
        ],
        // ******************************************************************************************
        // popup texts index 1
        // ******************************************************************************************
        [
            ["Les modifications sur cette page n'ont pas été sauvegardées.","Page changes not saved."], // 1.0
            ["Quitter sans sauvegarder","Quit without save"], // 1.1
            ["Ne pas quitter","Don't quit"], // 1.2
        ],



        // ******************************************************************************************
        // divers texts index 2
        // ******************************************************************************************
        [
            ["O.T.T.O","O.T.T.O"], // 2.0
        ],

        // ******************************************************************************************
        // divers applications texts index 3
        // ******************************************************************************************
        [
            ["Paramètres de la page","Page Settings"], // 3.0
            ["Paramètres calcul sous-titres","Subtitles settings"], // 3.1
            ["Paramètres Player","Player settings"], // 3.2
            ["Paramètres TimeLine","TimeLine settings"], // 3.3
            ["Paramètres Applications","Applications settings"], // 3.4



        ],

        // ******************************************************************************************
        // divers applications texts subtitles parameters
        // ******************************************************************************************
        [
            ["Lisibilité","Readability"], // 4.0
            ["Lisibilité Min","Min Readability"], // 4.1
            ["Lisibilité idéale","Ideal readability"], // 4.2
            ["Durée avant C.P.","Duration before shot"], // 4.3
            ["Durée après C.P.","Duration after shot"], // 4.4
            ["Intervalle","Duration between subtitles"], // 4.5
            ["Durée minimale","Minimum duration"], // 4.6
            ["Durée maximale","Maximum duration"], //4.7
            

            ["Longueur Maxi (blanc)","Max Length (white)"], //4.8
            ["Longueur Maxi (couleur)","Max Length (colored)"], //4.9

            ["Utiliser les changements de plan","Use shots"], //4.10

            ["Avance tcin","Advance tcin"], //4.11

            ["Mode de calcul :","Method of calculation : "], // 4.12
            ["Caractères/secondes","Characters by second"], // 4.13
            ["Mots/Minutes","Words by minutes"], // 4.14
 
            ["Alignement","Alignment"], // 4.15
            ["Gauche","Left"], // 4.16
            ["Droite","Right"], // 4.17
            ["Centré","Center"], // 4.18

            
            ["Collage ST si proche C.P.","ST collage so close C.P."], // 4.19
            ["Collage ST si coupure de phrase.","ST Collage mid-sentence."], // 4.20

            ["Débit Paroles","Speech Rate"], // 4.21

            ["Collage ST","ST Collage."], // 4.22

            ["Créer 1° Sous-titre","Create First Subtitle"], // 4.23
            ["Couleur par défaut","Default color"], // 4.24
            ["Utiliser la couleur précédente","Use previous color"], // 4.25

            ["Type sous-titrage","Subtitling format"], // 4.26
            ["Teletexte","Teletext"], // 4.27 (32)
            ["Teletexte Niveau 2","Teletext Level 2"], // 4.28 (33)

            ["Transparence","Transparency"], //4.29

            ["Position verticale","Baseline"], //4.30

        ],

        [
            ["Lisibilité","Readability"], // 5.0
            ["Durées","Durations"], // 5.1
            ["Sous-titres","Subtitles"], // 5.2
            ["Divers","miscellaneous"], //5.3
            ["Optimisation","Optimization"], // 5.4
            ["Transcription","Transcription"], // 5.5
            ["Lisibilité (ST Générés)","Readability (Generated ST)"], // 5.6

        ],


        // ******************************************************************************************
        // divers applications informations transcription
        // ******************************************************************************************
        [ 

            ["Transcription","Transcription"], // 6.0
            ["Sous-titres","Subtitles"], // 6.1


            ["Durée de la transcription","Transcription duration"], // 6.2
            ["Nombre de mots","Number of words"], // 6.3
            ["Nombre de phrases","Number of sentences"], // 6.4
            ["Lisibilité","Readability"], // 6.5
            ["Lisibilité avec C.P.","Readability with shots"], // 6.6

            ["Nombre de sous-titres","Number of subtitles"], // 6.7
            ["Lisibilité moyenne","Average readability"], // 6.8
            ["Longueur moyenne","Average length"], // 6.9
            ["Durée moyenne","Average Duration"], // 6.10
            ["Décalage maximum","Maximum Offset"], // 6.11
            ["Position décalage maximum","Maximum Offset Position"], // 6.12
            ["Décalage moyen","Average Offset"], // 6.13
            ["Nombre de C.P. (vidéo)","Number of shots (video)"], // 6.14
            ["Lisibilité (m/m)","Readability (w/m)"], // 6.15
            ["Lisibilité avec C.P. (m/m)","Readability with shots (w/m)"], // 6.16
            ["Lisibilité moyenne (m/m)","Average readability (w/m)"], // 6.17
        ],
        [
            ["Sous-titres","Subtitles"], // 7,0
            ["Fond noir","Black background"], //7,1
            ["TimeCode","TimeCode"], // 7,2
            ["Affiche du TimeCode","Display TimeCode"], // 7,3
            ["Affichage en ms","Display MS"], // 7,4
            ["Image","Picture"], //7.5
            ["Conserver les proportions","Keep the ratio"], //7.6
            ["Affichage","Display"], // 7,7
            ["Afficher zones C.P.","Display Shot Areas"], // 7,8
            ["Divers","Miscellianous"], // 7,9
            ["Magnétisme","Magnetism"], // 7,10
            ["Affichage images dans S.T.","Display frame in subtitle"], // 7,11
            ["Affichage Mode Transcription ","Transcription. Displayed Tracks"], // 7,12
            ["Affichage Mode Sous-titrage ","Subtitling. Displayed Tracks"], // 7,13

            ["Audio","Waveform"], // 7,14
            ["Audio hauteur minimale","Minimum height audio"], // 7,15
            ["Changements de plan","Shots"], // 7,16
            ["C.P. hauteur minimale","Minimum height shots"], // 7,17


            ["Transcription originale","Original transcription"], // 7,18
            ["Transcription corrigée","Corrected transcription"], // 7,19
            ["Sous-titres originaux","Original Subtitles"], // 7,20
            ["Sous-titres corrigés","Corrected Subtitles"], // 7,21

            ["Afficher positions verticales","Display vertical positions"], // 7,22
            ["Afficher les alignements","Display alignment"], // 7,23

            ["Transcription","Transcription"], // 7,24
            ["Sous-titrage","Subtitling"], // 7,25
            ["Afficher la toolsbar sous le sous-titre","Display toolbar below the subtitle"], // 7,26
            ["Afficher les boutons rotation des mots","Display Word rotation buttons"], // 7,27

            ["Taille police transcription","Transcription font size"], // 7,28

            ["Valeur de déplacement prédéfinie","Preset displacement value"], // 7,29
            ["Utiliser l'intervalle entre S.T.","Use the interval between S.T."], // 7,30
            ["Valeur","Value"], // 7,31
            ["Annuler les popups","Disable Popups"], // 7,32

        ],

        // PAGE DE LOGIN

        [
            ["Déconnexion.","Unconnect."], // 8,0
            ["Connectez-vous !","Login !"], // 8,1
            ["Valider","Connexion"], // 8,2
            ["Adresse email","Mail adress"], // 8,3
            ["Mémoriser mon adresse email","Save mail adress."], // 8,4
            ["Mot de passe","Password"], // 8,5
            ["Zone obligatoire","Resquested field"], // 8,6
            ["Mail ou mot de passe invalide.","Invalid mail or password."], // 8,7
            ["Se connecter via Single Sign-on","Connect By SSO."], // 8,8
            ["Vers la page d'indentification SSO","To SSO page"], // 8,9
        ],


        // ICON USER

        [
            ["Déconnexion.","Unconnect."], // 9,0
            ["Modifier le profil.","Edit user."], // 9,1
            ["Mes projets","Local project"], // 9,2
        ],

        // EDIT PROFIL

        [
            ["Mes informations","My profil"], // 10,0
            ["Nom","Last Name"], // 10,1
            ["Prénom","First Name"], // 10,2
            ["Adresse Mail","Email"], // 10,3
            ["Téléphone","Phone Number"], // 10,4
            ["Mot de passe","Password"], // 10,5
            ["Confirmer le mot de passe","Confirm Password"], // 10,6
            ["Image","Picture"], // 10,7
            ["Abandonner les modifications","Cancel changes"], // 10,8
            ["Valider les modifications","Save changes"], // 10,9

            ["Zone obligatoire","Required field"], // 10,10
            ["Mail déjà utilisé.","Mail already in use."], // 10,11
            ["Format de mail incorrect","Bad format mail address"], // 10,12
            ["Mot de passe trop court","Password too short"], // 10,13
            ["Mots de passe différents","Not same passwords"], // 10,14
            
        ],


    ];


function getText( cat, scat, lang)
{
    return alltexts[cat][scat][lang=='fr'?0:1];
}

export default getText;




